// extracted by mini-css-extract-plugin
module.exports = {"comment":"Comment_comment__EbnpG","header":"Comment_header__mLbu0","commentForm":"Comment_commentForm__F_ADP","showComments":"Comment_showComments__3CdQ9"};